import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { TranslateModule } from '@ngx-translate/core';
import { TrackingModule } from 'src/app/services/tracking/module';
import { TrialOfferCancelDialogComponent } from './trial-offer-cancel-dialog.component';
import { TrialOfferDialogComponent } from './trial-offer-dialog.component';

@NgModule({
  declarations: [TrialOfferDialogComponent, TrialOfferCancelDialogComponent],
  imports: [
    CommonModule,
    MatButtonModule,
    MatDialogModule,
    MatIconModule,
    MatProgressSpinnerModule,
    TranslateModule,
    TrackingModule,
  ],
})
export class TrialOfferDialogModule { }
